import { ProductType } from "~/common/props/orchestrator";
import { UiButton } from "~/components/ui-button";
import { QuantityManager } from "../../components/quantity-manager";
import { useProductSelector } from "../../product-selector.hook";
import { ProductSelectorProps } from "../../product-selector.types";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";

export const ProductSelectorSkin1 = ({
  product,
  selectedToppings,
  offerId,
  disable,
  addProductLabel,
  ...props
}: ProductSelectorProps) => {
  const { theme } = useGlobalStyles();
  const { t, hasProductInTheCart, hasDisabled, handleBuyButtonClick } =
    useProductSelector({
      ...props,
      product,
      selectedToppings,
      offerId,
    });

  return (
    <div>
      {hasProductInTheCart ? (
        <QuantityManager
          product={product}
          selectedToppings={selectedToppings}
          offerId={offerId}
          theme={theme}
        />
      ) : (
        <UiButton
          disabled={disable || hasDisabled}
          isFilled
          rightIcon={
            <span
              className={
                product.type === ProductType.Service
                  ? "icon-calendar"
                  : theme.config.button?.icon || "icon-cart"
              }
            />
          }
          onClick={() => handleBuyButtonClick()}
        >
          {product.type === ProductType.Service
            ? t("button.service")
            : addProductLabel || t("button.add")}
        </UiButton>
      )}
    </div>
  );
};
